import { useAppDispatch } from "hooks/useAppDispatch";
import { useEffect } from "react";
import { setPageBreadcrumb } from "store/slices/appLayout";

export const usePageBreadcrumb = (
  label?: string | null,
  to?: string | null
): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!label || !to) {
      return;
    }

    dispatch(setPageBreadcrumb({ label, to }));

    return () => {
      dispatch(setPageBreadcrumb(null));
    };
  }, [label, to, dispatch]);
};
